import Vue from 'vue'
import Vuex from 'vuex'

const state = {
    params: {
        page: 1,
        per_page: 30,
        q: {
            tel: '',
            start_time:"",
            end_time:""
        }
    }
}

const mutations = {
    changeBlacklistPage(state, val) {
        state.params = val
    }
}

export default {
    state,
    mutations
}